import { staticFormApiConnectorLegacy } from 'apiConnector/form/static';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { EMPTY, throwError } from 'rxjs';
import { catchError, mergeMap, timeoutWith, withLatestFrom } from 'rxjs/operators';
import { getFormProduct } from 'state/selectors/common/commonForm';
import type { EpicWithThunk } from 'state/state.common';

export function closeStaticFormEpic(timeoutInMillis: number = 60000, appScheduler?: SchedulerLike): EpicWithThunk {
  return (action$, state$, { oldHttpClient, frontLogger, selectors: { getStaticFormInfos } }) =>
    action$.pipe(
      ofType('WORKSPACE_TAB_DELETE_SESSION_REQUESTED'),
      withLatestFrom(state$),
      mergeMap(([{ id }, state]) => {
        const staticFormInfos = getStaticFormInfos(state, id);
        const product = getFormProduct(state, id);
        if (!staticFormInfos || !product) {
          return EMPTY;
        }

        const { negotiationId } = staticFormInfos;

        return negotiationId
          ? staticFormApiConnectorLegacy(oldHttpClient)
              .closeSession(negotiationId, product.productType, product.productSubtype)
              .pipe(
                mergeMap(() => EMPTY),
                timeoutWith(timeoutInMillis, throwError(new Error(`timeouted`)), appScheduler),
                catchError(error => {
                  frontLogger.error('Close static tab {TabId} session {@FrontError}', id, error);
                  return EMPTY;
                }),
              )
          : EMPTY;
      }),
    );
}
